<template>
    <vue-scroll :settings="{wheelPropagation:true}" v-if="!isMobile" class="games-menu-desktop">
        <div class="games-menu" v-if="expandedMenu">
            <div class="gamesm-form">
                <div class="gamesm-close-search-big" v-on:click.stop="clearSearch()" v-if="showSearchResults"></div>
                <div class="input-box">
                    <input v-on:keyup.enter="startSearch" class="input-text" type="text" :placeholder="$t('SEARCHBYOUTRIHGTNAME')" v-model="searchText">
                </div>
                <a class="button button-input"><i class="iconset icon-search"></i></a>
            </div>
            <div class="gamesm-search-box" v-if="showSearchResults">
                <vue-scroll :settings="{wheelPropagation:true}" class="gamesm-search-container" v-if="!searchError">
                    <div class="gamesm-search-item" v-for="group in searchResults" :key="group.name">
                        <div class="gamesm-searchi-header lb-sport sportbordercolor-outrights">{{group.name}}</div><!-- + sportMapping[outright.outrightsOfferId] -->
                        <div class="gamesm-searchi-content" v-for="outright in group.outrights" :key="outright.outrightId"
                            v-on:click.prevent="selectOutright({
                            outrightId: outright.outrightsOfferId,
                            eventType: 'outrights',
                            push: true
                            })" >
                            <p class="gamesm-searchi-teams">{{outright.name}}</p>
                            <p class="gamesm-searchi-tour">{{outright.tree[0].name}}</p>
                            <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(outright.endDate)}}</p>
                            <p v-else class="gamesm-searchi-date">{{outright.endDate | getLocalDate}}</p>
                        </div>
                    </div>
                </vue-scroll>
                <div class="gamesm-search-container" v-if="showSearchResults && searchError">
                    <div class="gamesm-search-item no-results">{{ $t(searchError) }}</div>
                </div>
            </div>
            <div class="games-menu-scroll">
                <!-- minimize is commented since all outright treeitems have the same icon-->
                <!-- <div class="gamesm-item minimize" @click="expandedMenu = !expandedMenu">
                    <div class="gamesm-item-content game-minimize">
                        <div class="gamesm-content-left">
                            <i class="sportsicon icon-arrowleft"></i>
                            <div class="gamesm-text">{{$t('MINIMIZE')}}</div>
                        </div>
                    </div>
                </div> -->
                <div class="gamesm-item" :class="{'is-selected': selectedTreeItemIds.sportId === 'all' }" @click="goTo()" >
                    <div class="gamesm-item-content game-all">
                        <div class="gamesm-content-left">
                            <i class="sportsicon icon-all"></i>
                            <div class="gamesm-text">{{$t('ALLOUTRIGHTS')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gamesm-item" v-for="treeItem in outrightTree" :key="treeItem.treeItemId" :class="{'is-selected': selectedTreeItemIds.sportId === treeItem.treeItemId }">
                    <div class="gamesm-item-content lb-sport game-border sportbordercolor-outrights" @click="goTo(String(treeItem.treeItemId))">
                        <div class="gamesm-content-left">
                            <i class="sportsicon lb-sport icon-outrights"></i>
                            <div class="gamesm-text">{{treeItem.name}} ({{countOutrights(treeItem)}})</div>
                        </div>
                        <div class="gamesm-content-right" v-if="treeItem.children.length" @click.stop="updateTreeItem(treeItem.treeItemId)">
                            <span class="gamesm-arrow" :class="treeItem.opened ? 'is-selected' : ''" />
                        </div>
                    </div>
                    <OutrightsMenuTreeItem
                    v-if="treeItem.children.length"
                    :treeItem="treeItem"
                    :countOutrights="countOutrights"
                    @selectOutright="selectOutright"
                    @goFurther="goFurther(treeItem.treeItemId, $event)" />
                </div>
            </div>
        </div>
    </vue-scroll>
    <vue-scroll :settings="{wheelPropagation:true}" v-else class="offer-menu-box">
        <div class="offer-menu sport">
            <!-- TODO add searchbox functionality -->
            <div class="offer-menu-item all" v-on:click.stop="showSearchBox" v-if="!isResultsPage">
                <i class="iconset icon-search menu-singleicon"></i>
                <div class="gamesm-text">{{$t('SEARCHEVENTS')}}</div>
            </div>
            <div class="offer-menu-item all" @click="toggleGamesMenu()" v-if="pagetype != 'results'">
                <i class="iconset icon-calendar menu-singleicon"></i>
                <div class="gamesm-text">{{ $t('CALENDAR') }}</div>
            </div>
            <div class="offer-menu-item all" v-on:click="leaguesFilter = !leaguesFilter;">
                <i class="iconset icon-leagues menu-singleicon"></i>
                <div class="gamesm-text">{{ $t('LEAGUES') }}</div><!-- TODO check naming -->
            </div>
            <div class="offer-menu-item all" @click="goTo()"
             :class="selectedTreeItemId == undefined ? 'is-selected' : ''">
                <i class="sportsicon icon-all"></i>
                <div class="gamesm-text">{{$t('ALLOUTRIGHTS')}}</div>
            </div>

            <div class="offer-menu-item lb-sport sportbordercolor-soccer"
            v-for="treeItem in outrightTree"
            :key="treeItem.treeItemId"
            :class="selectedTreeItemId == treeItem.treeItemId ? 'is-selected' : ''" >
                <div @click="goTo(String(treeItem.treeItemId))">
                        <i class="icon-outrights lb-sport"></i>
                        <div class="gamesm-text">{{treeItem.name}}</div>
                </div>
            </div>
        </div>
        <!-- search field -->

        <div class="offer-menu-search" v-if="showSearchBox" :class="{active:searchBox}">
            <div class="input-box">
                <div class="loading-container" v-if="searchLoading"><img src="../../../assets/img/loading.svg"></div>
                <input class="input-text" v-on:keyup.enter="startSearch" v-model="searchText" type="text" :placeholder="$t('SEARCHBYOUTRIGHTNAME')">
                <div class="offer-menu-search-btn" v-on:click.stop="startSearch"></div>
                <div class="gamesm-close-search-big" v-on:click.stop="clearSearch()" v-if="showSearchResults"></div>
            </div>
        </div>

        <!-- search results -->
        <div class="gamesm-search-box 3" v-if="showSearchResults">
            <div class="gamesm-search-container" v-if="!searchError">
                <div class="gamesm-search-item" v-for="group in searchResults" :key="group.name">
                        <div class="gamesm-searchi-header lb-sport sportbordercolor-outrights">{{group.name}}</div>
                        <div class="gamesm-searchi-content" v-for="outright in group.outrights" :key="outright.outrightId"
                            v-on:click.prevent="selectOutright({
                            outrightId: outright.outrightsOfferId,
                            eventType: 'outrights',
                            push: true
                            })" >
                            <p class="gamesm-searchi-teams">{{outright.name}}</p>
                            <p class="gamesm-searchi-tour">{{outright.tree[0].name}}</p>
                            <p v-if="pagetype != 'results'" class="gamesm-searchi-date">{{$predefinedLocalDateFormat(outright.endDate)}}</p>
                            <p v-else class="gamesm-searchi-date">{{outright.endDate | getLocalDate}}</p>
                        </div>
                    </div>
            </div>
            <div class="gamesm-search-container" v-if="showSearchResults && searchError">
                <div class="gamesm-search-item no-results">{{ $t(searchError) }}</div>
            </div>
        </div>
        <!-- leagues filter -->
        <div class="games-menu fadeInDownMobileFilter" v-if="leaguesFilter" :class="{active:leaguesFilter}">
            <!-- sports item -->
            <div v-if="!isResultsPage" class="gamesm-item all-sports" v-on:click="goTo()"
            :class="selectedTreeItemId == undefined ? 'is-selected' : ''">
                <div class="gamesm-item-content">
                    <div class="gamesm-content-left">
                        <i class="sportsicon icon-all"></i>
                        <div class="gamesm-text">{{$t('ALLSPORTS')}}</div>
                    </div>
                </div>
            </div>

             <template v-for="treeItem in outrightTree" >
                 <div class="gamesm-item" :key="treeItem.treeItemId"
                 :class="selectedTreeItemId == treeItem.treeItemId ? 'is-selected' : ''">
                    <div class="gamesm-item-content lb-sport game-border sportbordercolor-soccer"
                     @click="goTo(String(treeItem.treeItemId))">
                        <div class="gamesm-content-left" >
                            <i class="sportsicon lb-sport icon-outrights"></i>
                            <div class="gamesm-text">{{treeItem.name}} ({{countOutrights(treeItem)}})</div>
                        </div>
                        <div class="gamesm-content-right" v-if="treeItem.children.length" @click.stop="updateTreeItem(treeItem.treeItemId)">
                            <span class="gamesm-arrow" :class="treeItem.opened ? 'is-selected' : ''" />
                        </div>
                    </div>
                    <OutrightsMenuTreeItem
                    v-if="treeItem.children.length"
                    :selectedTreeItemIds="selectedTreeItemIds"
                    :treeItem="treeItem"
                    :countOutrights="countOutrights"
                    @goFurther="goFurther(treeItem.treeItemId, $event)" />
                </div>
             </template>
        </div>
    </vue-scroll>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import OutrightsMenuTreeItem from './OutrightsMenuTreeItem.vue';

export default {
    name: 'outrightsMenu',
    props: ['pagetype'],
    components:
    {
        OutrightsMenuTreeItem,
    },
    data()
    {
        return {
            expandedMenu: true,
            leaguesFilter: false,
            selectedTreeItemId: undefined,
            searchBox: false,
            searchText: '',
            searchError: false,
            searchResults: {},
            showSearchResults: false,
            searchLoading: false,
            selectedTreeItemIds: {
                sportId: null,
                categoryId: null,
                tournamentId: null,
            },
            isFirstRender: true,
        };
    },
    created()
    {
        const me = this;

        if (me.$route.params.pathMatch !== undefined)
        {
            const routes = me.$route.params.pathMatch.split(',');
            me.selectedTreeItemIds.sportId = parseInt(routes[0], 10);
            me.setSelectedOutrightsItems(routes);
        }
        else
        {
            const firstTreeItem = me.outrightTree[0].treeItemId;
            me.goTo(String(firstTreeItem));
            me.selectedTreeItemIds.sportId = firstTreeItem;
            me.setSelectedOutrightsItems(firstTreeItem);
        }
    },
    methods:
    {
        ...mapActions({
            selectOutright: 'selectOutright',
            updateTreeItem: 'updateTreeItem',
            setSelectedOutrightsItems: 'setSelectedOutrightsItems',
        }),
        countOutrights(item)
        {
            const me = this;
            let outrightCount = 0;

            // count outright if there is only 1 treeItem in its tree, but it won't be shown in tree menu
            /* if (me.outrightsTreeMapping[item.treeItemId])
            {
                for (const outright of me.outrightsTreeMapping[item.treeItemId].outrights)
                {
                    if (outright.tree.length === 1)
                    {
                        outrightCount += 1;
                    }
                }
            } */
            if (item.children && item.children.length)
            {
                for (const child of item.children)
                {
                    if (me.outrightsTreeMapping[child.treeItemId])
                    {
                        outrightCount += me.outrightsTreeMapping[child.treeItemId].outrights.length;
                    }
                    if (child.children.length)
                    {
                        outrightCount += me.countOutrights(child);
                    }
                }
            }
            else
            {
                /* if (!me.outrightsTreeMapping[item.treeItemId])
                {
                    return 0;
                } */
                outrightCount = me.outrightsTreeMapping[item.treeItemId].outrights.length;
            }
            return outrightCount;
        },
        goFurther(treeItemId, val)
        {
            const me = this;
            me.goTo(`${treeItemId},${val}`);
        },
        goTo(val)
        {
            const me = this;
            me.selectedTreeItemId = val;
            me.selectedOutrightId = null;
            me.leaguesFilter = false;

            if (me.$route.params.pathMatch !== val)
            {
                me.$router.push({
                    params:
                {
                    pathMatch: val,
                },
                });
            }
            me.selectOutright({
                outrightId: null,
                eventType: 'outrights',
                push: true,
            });
        },
        toggleGamesMenu()
        {
            const me = this;
            me.leaguesFilter = false;
            me.$emit('toggleGamesMenu');
        },
        async startSearch()
        {
            const me = this;

            me.leaguesFilter = false;

            me.searchResults = {};

            const searchResultsOut = {};

            me.searchLoading = true;

            if (me.searchText.length >= 3)
            {
                me.searchError = false;

                const dateNow = moment().utc().format('YYYY-MM-DD HH:mm:ss');

                let params = {};

                if (me.pagetype !== 'results')
                {
                    params = {
                        status: 'active,block',
                        minoffer: '1',
                        search: me.searchText,
                        startDate: dateNow,
                        endDate: moment(dateNow).add(365, 'd').format('YYYY-MM-DD HH:mm:ss'),
                    };
                }
                else
                {
                    params = {
                        status: 'finished',
                        minoffer: '1',
                        search: me.searchText,
                        startDate: moment(dateNow).subtract(30, 'd').format('YYYY-MM-DD HH:mm:ss'),
                        endDate: dateNow,
                        results: '1',
                    };
                }

                const data = await me.offerHandling.callOffer(`/${me.globals.langCode}/outrights/getOutrightsOffer`, params);

                const outrights = data.data;

                if (outrights.length > 0)
                {
                    for (let i = 0; i < outrights.length; i += 1)
                    {
                        const outright = outrights[i];

                        const { name } = outright.tree[outright.tree.length - 1];

                        if (searchResultsOut[outright.outrightsOfferId] === undefined
                            && !searchResultsOut[name])
                        {
                            searchResultsOut[name] = {
                                name,
                                outrights: [],
                            };
                        }

                        searchResultsOut[name].outrights.push(outright);
                    }
                    me.searchError = false;
                }
                else
                {
                    me.searchError = 'NORESULTSFOUND';
                }
            }
            else
            {
                me.searchError = 'SEARCHTERMTOOSHORT';
            }

            me.showSearchResults = true;
            me.searchResults = searchResultsOut;
            me.searchLoading = false;
            me.searchBox = true;
        },
        clearSearch()
        {
            const me = this;

            me.searchBox = false;
            me.searchError = false;
            me.showSearchResults = false;
            me.searchResults = {};
            me.searchText = '';
            me.searchError = false;
        },
        showSearchBox()
        {
            const me = this;
            me.searchBox = !me.searchBox;
            me.searchText = '';

            if (!me.searchBox)
            {
                me.showSearchResults = false;
            }

            me.$nextTick(() =>
            {
                if (me.$refs.searchBoxInput)
                {
                    me.$refs.searchBoxInput.focus();
                }
            });
        },
    },
    computed: {
        ...mapGetters([
            'globals',
            'isMobile',
            'offerHandling',
            'outrightTree',
            'outrightsTreeMapping',
            'selectedOutrightsItems',
            'getOutrights',
        ]),
        isResultsPage()
        {
            const me = this;

            return (me.$route.path.indexOf('results') !== -1);
        },
    },
    watch: {
        '$route.params.pathMatch'(val)
        {
            const me = this;
            if (val === undefined)
            {
                me.selectedTreeItemIds.sportId = 'all';
                return;
            }

            const selectedIds = val.split(',');

            me.selectedTreeItemIds.sportId = parseInt(selectedIds[0], 10) || null;
            // check if category and tournament need to have is-selected class
            /* me.selectedTreeItemIds.categoryId = parseInt(selectedIds[1], 10) || null;
            me.selectedTreeItemIds.tournamentId = parseInt(selectedIds[2], 10) || null; */
        },
        outrightTree(val)
        {
            const me = this;
            if (val.length && me.filteredOutrights === undefined && me.$route.params.pathMatch !== undefined)
            {
                let selectedIds = me.$route.params.pathMatch.split(',');

                if (selectedIds.length > 1)

                {
                    selectedIds = selectedIds.slice(0, -1);

                    me.setSelectedOutrightsItems(selectedIds);
                    me.$router.push({
                        params:
                {
                    pathMatch: selectedIds.join(','),
                },
                    });
                }
                else if (selectedIds.length === 1)
                {
                    me.setSelectedOutrightsItems(selectedIds);
                    me.$router.push({
                        params:
                        {
                            pathMatch: selectedIds[0],
                        },
                    });
                }
                else
                {
                    me.setSelectedOutrightsItems([]);
                    me.$router.push({
                        params:
                        {
                            pathMatch: undefined,
                        },
                    });
                }
            }
        },
    },
};
</script>
